import { all, spawn, fork, call } from "redux-saga/effects";
import { watchFetchCompetitors } from "./features/sagas/competitorsSaga";
import { watchfetchBusinessUnitAccDetail } from "./features/sagas/businessUnitAccDetailsSaga";
import { watchFetchQuestionsPrompterData } from "./features/sagas/questionsPrompterDataSaga";
import { watchFetchDocuments } from "./features/sagas/documentsSaga";
import { watchFetchTechlandscape } from "./features/sagas/techLandscapeSaga";
import { watchFetchKeyTechnologies } from "./features/sagas/keyTechnologySaga";
import { watchFetchAccBuNudgeData } from "./features/sagas/accountBuNudgesSaga";
import { watchFetchGrowthOpportunitiesByAccountAndClient } from "./features/sagas/growthOpportunitiesByAccountAndClientSaga";
import { watchFetchAccountContactData } from "./features/sagas/accountContactsSaga";
import { watchFetchEvents } from "./features/sagas/eventsSaga";
import { watchFetchNewProject } from "./features/sagas/newProjectsSaga";
import { watchFetchcompCompetitors } from "./features/sagas/companyCompareSaga";
import { watchfetchCompBuFinancial } from "./features/sagas/companyBuFinancialsSaga";
import { watchFetchClientNudgeData } from "./features/sagas/clientNudgeSaga";
import { watchFetchRevenueAnalysis } from "./features/sagas/fetchRevenueAnalysisSaga";
import { watchFetchGeoWiseRevenueAnalysis } from "./features/sagas/fetchGeoWiseRevenueAnalysisSaga";
import {
  watchFetchAccountDetails,
  watchFetchAccountInfo,
} from "./features/sagas/accountsSaga";
import { watchfetchCompFinancial } from "./features/sagas/companyFinancialsSaga";
import { watchFetchSegments } from "./features/sagas/segmentsSaga";
import { watchFetchKeyConversation } from "./features/sagas/keyConversationSaga";
import { watchClosureSubmission } from "./features/sagas/closureAgentSaga";
import { watchChampionSaga } from "./features/sagas/championAgentSaga";
import { watchRenewalRequests } from "./features/sagas/renewalAgentSaga";
import watchDeliveryExcellence from "./features/sagas/deliveryExcellenceSaga";
import { watchGetLiveAccountsSaga } from "./features/sagas/fetchLiveAccountsSaga";
import { watchFetchDynamicTabs } from "./features/sagas/dynamicTabsSaga";
import { watchDemoRequestSubmission } from "./features/sagas/demoRequestSaga";
import { watchOpportunitiesData } from "./features/sagas/opportunities/opportunitiesSaga";
import { watchBattleCardData } from "./features/sagas/opportunities/battleCardSaga";
import { watchNewsData } from "./features/sagas/opportunities/newsSaga";
import { watchBusinessCaseData } from "./features/sagas/opportunities/businessCaseSaga";
import { watchContactCardData } from "./features/sagas/opportunities/contactCardSaga";
import { watchValueSellingCardData } from "./features/sagas/opportunities/valueSellingCardSaga";
import { watchNextStepCardData } from "./features/sagas/opportunities/nextStepCardSaga";
import { watchConvertToWinSaga } from "./features/sagas/opportunities/convertToWinSaga";
import { watchWinOpportunitiesSaga } from "./features/sagas/opportunities/winOpportunitiesSaga";
import { watchCreateDealSaga } from "./features/sagas/opportunities/increaseDealSizeSaga.js/createDealSaga";
import { watchListDealsSaga } from "./features/sagas/opportunities/increaseDealSizeSaga.js/listDealsSaga";
import { watchSpotContactsSaga } from "./features/sagas/targetedReachout/spotOpportunitiesSaga";
import { watchspotContactOppMapSaga } from "./features/sagas/targetedReachout/spotContactOppMapSaga";
import { watchIncreaseDealSizeCardData } from "./features/sagas/opportunities/increaseDealSizeCardSaga";
import {
  watchglobalMemSaga,
  watchListGlobalMemDocsSaga,
  watchListGlobalMemSaga,
} from "./features/sagas/memory/globalMemorySaga";
import { watchNudgesNewSubmission } from "./features/sagas/nudgesNewSaga";
import { watchMeetingPrepsSaga } from "./features/sagas/meetingPreps/meetingPrepsSaga";
import { watchBattleCardMpData } from "./features/sagas/meetingPreps/battleCardSaga";
import { watchNextStepsMpData } from "./features/sagas/meetingPreps/nextStepsMpCardSaga";
import spotContactBCReducer from "./features/reducers/targetedReachoutReducers/spotContactBattleCardReducer";
import { watchspotContactBCSaga } from "./features/sagas/targetedReachout/spotContactBattleCardSaga";
import { watchpitchWoData } from "./features/sagas/opportunities/pitchCardWoSaga";
import { watchMeetingPrepPromptersCardData } from "./features/sagas/meetingPreps/promptersCardSaga";
import { watchOperationsAndSupplyChainSubmission } from "./features/sagas/operationsSupplyChainSaga";
import { watchCorporateAndOrgStructureSubmission } from "./features/sagas/corporateAndOrgStructureSaga";
import { watchCompetitorProfileSubmission } from "./features/sagas/competitorProfileSaga";
import { watchCompetitorProfileV1Submission } from "./features/sagas/competitorProfileV1Saga";
import { watchCompetitorProfileV3Submission } from "./features/sagas/competitorProfileV3Saga";
import { watchCompetitorListSubmission } from "./features/sagas/competitorListSaga";
import { watchFetchSelfFinancialsGiq } from "./features/sagas/selfFinancialGiqSaga";
import { watchCompetitorProfileV4Submission } from "./features/sagas/competitorProfileV4Saga";
import createCompetitorSaga from "./features/sagas/createCompetitorSaga";
import { watchBaselineMarketDetailsSubmission } from "./features/sagas/baselineMarketDetailsSaga";
import { watchToggleCompetitorStatus } from "./features/sagas/competitorStatusSaga";
import suggestedCompetitorWatcher from "./features/sagas/suggestedCompetitorSaga";
import fetchSuggestedCompetitorsWatcher from "./features/sagas/fetchSuggestedCompetitorSaga";
import watchClientIndustriesCompetitorsSaga from "./features/sagas/fetchClientIndustriesCompetitorsSaga";
import { watchForgotPassword } from "./features/sagas/forgotPasswordSaga";
import { watchFetchExistingSubdimensions } from "./features/sagas/fetchExistingSubdimensionsSaga";
import { watchNewUpdatesSaga } from "./features/sagas/newUpdatesSaga";
import updateCompetitorProfileWatcher from "./features/sagas/updateCompetitorProfileSaga";
import competitorAiTableSaga from "./features/sagas/competitorAiTableSaga";
import { watchFetchBenchmarkingSubmission } from "./features/sagas/fetchBenchmarkingSaga";
import createBenchmarkSaga from "./features/sagas/createBenchmarkSaga";
import benchmarkGenerationStatusSaga from "./features/sagas/benchmarkGenerationStatusSaga";

export default function* rootSaga() {
  const longLivedSagas = []; // Persistent tasks
  const shortLivedSagas = [
    watchFetchCompetitors,
    watchfetchBusinessUnitAccDetail,
    watchFetchQuestionsPrompterData,
    watchFetchDocuments,
    watchFetchTechlandscape,
    watchFetchKeyTechnologies,
    watchFetchAccBuNudgeData,
    watchFetchGrowthOpportunitiesByAccountAndClient,
    watchFetchAccountContactData,
    watchFetchEvents,
    watchFetchNewProject,
    watchFetchcompCompetitors,
    watchfetchCompBuFinancial,
    watchFetchClientNudgeData,
    watchFetchRevenueAnalysis,
    watchFetchGeoWiseRevenueAnalysis,
    watchFetchAccountInfo,
    watchFetchAccountDetails,
    watchfetchCompFinancial,
    watchFetchSegments,
    watchFetchKeyConversation,
    watchClosureSubmission,
    watchChampionSaga,
    watchRenewalRequests,
    watchDeliveryExcellence,
    watchGetLiveAccountsSaga,
    watchFetchDynamicTabs,
    watchDemoRequestSubmission,
    watchOpportunitiesData,
    watchBattleCardData,
    watchNewsData,
    watchBusinessCaseData,
    watchContactCardData,
    watchValueSellingCardData,
    watchNextStepCardData,
    watchConvertToWinSaga,
    watchWinOpportunitiesSaga,
    watchCreateDealSaga,
    watchListDealsSaga,
    watchSpotContactsSaga,
    watchspotContactOppMapSaga,
    watchIncreaseDealSizeCardData,
    watchglobalMemSaga,
    watchListGlobalMemSaga,
    watchListGlobalMemDocsSaga,
    watchNudgesNewSubmission,
    watchMeetingPrepsSaga,
    watchBattleCardMpData,
    watchNextStepsMpData,
    spotContactBCReducer,
    watchspotContactBCSaga,
    watchpitchWoData,
    watchMeetingPrepPromptersCardData,
    watchOperationsAndSupplyChainSubmission,
    watchCorporateAndOrgStructureSubmission,
    watchCompetitorProfileSubmission,
    watchCompetitorProfileV1Submission,
    watchCompetitorProfileV3Submission,
    watchCompetitorProfileV4Submission,
    watchCompetitorListSubmission,
    watchFetchSelfFinancialsGiq,
    createCompetitorSaga,
    watchBaselineMarketDetailsSubmission,
    watchToggleCompetitorStatus,
    suggestedCompetitorWatcher,
    fetchSuggestedCompetitorsWatcher,
    watchClientIndustriesCompetitorsSaga,
    watchForgotPassword,
    watchFetchExistingSubdimensions,
    watchNewUpdatesSaga,
    updateCompetitorProfileWatcher,
    competitorAiTableSaga,
    watchFetchBenchmarkingSubmission,
    createBenchmarkSaga,
    benchmarkGenerationStatusSaga,
  ]; // Page-specific API calls

  yield all([
    // Handle long-lived sagas (auto-restart mechanism)
    ...longLivedSagas?.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break; // Exit loop if saga completes successfully
          } catch (error) {
            console.error(`Error in ${saga.name}, restarting...`, error);
          }
        }
      })
    ),

    // Handle short-lived sagas (cancelled when rootSaga stops)
    ...shortLivedSagas.map(fork),
  ]);
}
